var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.visible,"fullscreen":"","show-close":false},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticClass:"full-wrapper"},[_c('span',[_vm._v("推广活动")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }